import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IAddMasterPassRequest {
  merchantId: number;
  restriction: boolean;
  clientId: number;
  encKey: string;
  macKey: string;
  terminalGroupId: string;
}

async function addMasterPass(data: IAddMasterPassRequest): Promise<any> {
  try {
    return (await axiosInstance.post("/MasterPass/AddDefinition", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useAddMasterPass() {
  return useMutation<any, Error, IAddMasterPassRequest>(
    (variables) => addMasterPass(variables)
  );
}
